import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { dailyProcessActionType } from '../actions/actionTypes';

function DailyProcessFilterListConfig(state = { ...basicListAddEditDltInitialState }, action = null) {
  switch (action.type) {
    case dailyProcessActionType.RESET_UPSERT_ERROR:
      return {
        ...state,
        upsertRequestError: [],
      };
    case dailyProcessActionType.SET_DP_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case dailyProcessActionType.RESET_UPSERT_VALUE:
      return {
        ...state,
        upsertRequest: action.data.upsertRequest,
        upsertRequestError: action.data.upsertRequestError,
        upsertRequestedOn: action.data.upsertRequestedOn,
        upsertRequestProcessedOn: action.data.upsertRequestProcessedOn,
        upsertData: action.data.upsertData,
        loading: false,
      };
    case dailyProcessActionType.RESET_DELETE_VALUE:
      return {
        ...state,
        deleteRequest: action.data.deleteRequest,
        deleteRequestError: action.data.deleteRequestError,
        deleteRequestedOn: action.data.deleteRequestedOn,
        deleteRequestProcessedOn: action.data.deleteRequestProcessedOn,
        deleteData: action.data.deleteData,
      };
    case dailyProcessActionType.GET_DP_HEADER_DETAIL_RESPONSE:
      return {
        ...state,
        headerData: action.data,
        detailRequestProcessedOn: new Date(),
        loading: false,
      };
    default:
      return null;
  }
}

const DailyProcessFilterListREQRES = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    // log request
    case dailyProcessActionType.GET_DP_DETAIL_RESPONSE:
      return {
        ...state,
        detailData: action.data,
        detailRequestProcessedOn: new Date(),
        loading: false,
      };
    case dailyProcessActionType.RESET_DP_TAB_DETAIL_VALUE:
      return {
        ...state,
        detailData: null,
        selectedTab: action.data.tab,
        detailRequestProcessedOn: new Date(),
        loading: false,
      };
    case dailyProcessActionType.RESET_DP_SUB_TAB_DETAIL_VALUE:
      return {
        ...state,
        detailData: null,
        selectedSubTab: action.data.tab,
        detailRequestProcessedOn: new Date(),
        loading: false,
      };
    case dailyProcessActionType.LOG_DP_DETAIL_REQUEST:
      return {
        ...state,
        detailRequestedOn: new Date(),
        loading: true,
      };
    case dailyProcessActionType.RESET_DP_LOOKUPDATA:
      return {
        ...state,
        pageLevelLookupData: action.data,
      };
    default:
      return state;
  }
};

function DailyProcessFilterListSERVER(state = { ...basicListAddEditDltInitialState }, action = null) {
  switch (action.type) {
    // log request
    case dailyProcessActionType.GET_DP_DETAIL_ERROR:
      return {
        ...state,
        detailRequestError: action.data,
        detailRequestProcessedOn: new Date(),
        loading: false,
      };
    case dailyProcessActionType.RESET_SERVER_VALUE:
      return {
        ...state,
        serverRequestError: action.data && action.data.serverRequestError,
      };
    case dailyProcessActionType.SET_DP_SEQUENCE_ERROR:
      return {
        ...state,
        sequenceRequestError: action.data && action.data.serverRequestError,
      };
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return null;
  }
}

const DailyProcess = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  const stateConfig = DailyProcessFilterListConfig(state, action);
  const stateReqRes = DailyProcessFilterListREQRES(state, action);
  const stateServer = DailyProcessFilterListSERVER(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  if (stateServer !== null) {
    return stateServer;
  }
  return state;
};

export default DailyProcess;
